import { App } from 'antd';

import { useIntl, useModel, useRequest } from '@umijs/max';

import { OptionType } from '@/types';

import { findDateRangeDevices, getDevices } from './index';

export const useGetDevices = () => {
  const intl = useIntl();
  const { message } = App.useApp();

  return useRequest(getDevices, {
    cacheKey: 'getDevices',
    onError: () => {
      message.error(intl.formatMessage({ id: 'common.fetch.failure' }));
    },
    staleTime: Infinity,
  });
};

export const useGetDevicesOptions = () => {
  const intl = useIntl();
  const { message } = App.useApp();

  return useRequest(getDevices, {
    cacheKey: 'getDevicesOptions',
    formatResult: result => result.map(({ id, name }) => ({ label: name, value: id })),
    onError: () => {
      message.error(intl.formatMessage({ id: 'common.fetch.failure' }));
    },
    staleTime: Infinity,
  });
};

export const useFindDateRangeDeviceOptions = () => {
  const intl = useIntl();
  const { message } = App.useApp();
  const { setSelectedDevice } = useModel('selectedDevice');

  return useRequest(findDateRangeDevices, {
    cacheKey: 'findDateRangeDeviceOptions',
    formatResult: result => result.map(({ id, name }) => ({ label: name, value: id })),
    manual: true,
    onError: () => {
      message.error(intl.formatMessage({ id: 'common.fetch.failure' }));
    },
    onSuccess: (data: OptionType[]) => {
      if (data.length > 0) {
        setSelectedDevice(data[0]);
        return;
      }
      setSelectedDevice(null);
    },
  });
};
